import { ASSET_TYPES } from '@/services/AssetService/config';
import Env from '@/helpers/Env';
import { getUrlFloat, getUrlBoolean, getUrlString } from '@/helpers/UrlParam';

// **********************************************************************
// URLS
// **********************************************************************
export const fonts = {};

export const models = {};

export const images = {};

export const textures = {
  t_tractor: `assets/textures-o/area2/tractor.ktx2`,
  t_corn2: `assets/textures-o/area3/corn2.ktx2`,
  t_person: `assets/textures-o/area3/person.ktx2`,
  t_pub: `assets/textures-o/area3/pub.ktx2`,
  t_cloud: `assets/textures-o/area3/cloud.ktx2`,
  t_truck: `assets/textures-o/area3/truck.ktx2`,
  t_wasps: `assets/textures-o/area3/wasps.ktx2`,

  // t_score_3: `assets/textures-o/area3/score_3.ktx2`,
  t_score_3: `assets/textures-o/area1/score_1.ktx2`,
};

export const jsons = {};

export const sounds = {};

const videos = {};

export const urls = {
  ...fonts,
  ...models,
  ...images,
  ...textures,
  ...sounds,
  ...videos,
};

// **********************************************************************
// MANIFEST
// **********************************************************************
export const manifest = {
  id: 'pub',
  items: [
    ...Object.entries(fonts).map(([id, url]) => ({ id, url })),
    ...Object.entries(models).map(([id, url]) => ({ id, url })),
    ...Object.entries(images).map(([id, url]) => ({ id, url })),
    ...Object.entries(textures).map(([id, url]) => ({ id, url })),
    ...Object.entries(sounds).map(([id, url]) => ({ id, url })),
    ...Object.entries(jsons).map(([id, url]) => ({ id, url })),
    ...Object.entries(videos).map(([id, url]) => ({ id, url })),
  ],
};
